<template>
    <b-modal
        ref="dialog"
        title-tag="h2"
        :lazy="true"
        @hidden="close"
        title="Print Certificate"
    >
        <b-alert :show="showAlert" variant="warning">
            <i class="cus-error"></i>
            Generated certificates will be stored in patient Documents
        </b-alert>
        <b-form-group label-cols="3" label="Type:" label-for="type">
            <b-select v-model="type" class="form-control">
                <option value="0">Rabies</option>
                <option value="1">Reminders</option>
                <option value="2">Vaccination</option>
            </b-select>
        </b-form-group>

        <b-form-group
            label-cols="3"
            label="Reminders:"
            label-for="reminders"
            v-if="type !== '1'"
        >
            <b-select v-model="reminders" class="form-control">
                <option value="0">Do not include reminders</option>
                <option value="1">Include reminders</option>
            </b-select>
        </b-form-group>

        <b-form-group
            label-cols="3"
            label="Veterinarian:"
            label-for="veterinarian"
            v-if="type === '2'"
        >
            <b-select
                v-model="veterinarian"
                :options="veterinarianOptions"
                class="form-control"
            ></b-select>
        </b-form-group>

        <template v-slot:modal-footer>
            <loader v-if="isLoading" :margin="1" />

            <b-button
                class="mr-auto"
                variant="secondary"
                @click="close"
                v-if="!isLoading"
            >
                Cancel
            </b-button>

            <b-button v-if="!isLoading" variant="primary" @click="print">
                Print
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import Loader from "@/module/commons/loader";
import axios from "axios";

export default {
    components: {
        Loader
    },
    props: {
        patientDetails: {
            type: Object
        }
    },
    data() {
        return {
            type: "0",
            reminders: "0",
            isLoading: false,
            veterinarian: "",
            veterinarianOptions: [],
            showAlert: true
        };
    },
    watch: {
        type(value) {
            if (value != 1) {
                this.showAlert = true;
            } else {
                this.showAlert = false;
            }
        }
    },
    methods: {
        open() {
            this.$refs.dialog.show();
            this.fetchVeterinarians();
        },
        close() {
            this.$refs.dialog.hide();
        },
        async fetchVeterinarians() {
            try {
                const res = await axios.get(
                    `${process.env.BARRAMUNDI}actor/staff/business/providers`
                );

                const response = res.data.response;

                if (response && response.resource && response.resource.data) {
                    let options = this.properVetList(response.resource.data);
                    this.veterinarianOptions = options;

                    let currentActor = this.$root.currentActor.id;
                    let isProvider = options.find(
                        opt => opt.value === currentActor
                    );

                    if (isProvider) {
                        this.veterinarian = currentActor;
                    } else {
                        this.veterinarian = options[0] ? options[0].value : "";
                    }
                } else {
                    throw new Error("Unable to fetch veterinarian list.");
                }
            } catch (e) {
                this._message(e.message, "danger");
            }
        },
        properVetList(rawData = []) {
            let result = [];

            for (const record of rawData) {
                result.push({
                    text: record.actor.label,
                    value: record.actor.id
                });
            }

            return result;
        },
        async print() {
            try {
                let formData = new FormData();
                formData.append("id", this.patientDetails.id);
                formData.append("email_type", "");
                formData.append("first_name", "");
                formData.append("last_name", "");
                formData.append("type", this.type);
                formData.append("reminder-option", this.reminders);
                formData.append("veterinarian", this.veterinarian);
                formData.append("fax_subject", "");
                formData.append("fax_note", "");
                formData.append("include_cover_letter", "true");
                formData.append("subject", "");
                formData.append("message", "");
                formData.append("action", "print");
                formData.append(
                    "timestamp",
                    Math.floor(new Date().getTime() / 1000)
                );

                this.isLoading = true;

                const res = await axios.post(
                    `${process.env.CI_APPS}patient/record/export`,
                    formData
                );

                if (Number(res.data.state) === 0) {
                    this.isLoading = false;
                    this._message(res.data.message);
                    this.$emit("onsuccess", { cert_type: this.type });
                    this.close();

                    if (res.data.uri) {
                        window.open(res.data.uri);
                    }
                } else {
                    throw new Error(res.data.message);
                }
            } catch (e) {
                this.isLoading = false;
                this._message(e.message, "danger");
            }
        }
    }
};
</script>
